import { useState } from 'react'
import { Button, Card, Form } from 'react-bootstrap'
import { Trash2 } from 'react-feather'
import { SystemMessageContext } from '../../../../../context/SystemMessageContext'
import { useContext } from 'react'

const DayParting = ({ data, setData, setIsDisabled}) => {
    const { showSystemMessage } = useContext(SystemMessageContext)

    const getDayPartingFromData = (campaignData) => {        
        if (!campaignData) {
            return []
        }

        if (Array.isArray(campaignData?.dayparting?.schedule)) {
            return campaignData.dayparting.schedule
        }

        return []
    }

    const getDisplayData = (data) => {        
        let newArray = []
        data.forEach((item) => {
            // Check if day already exists in newArray. If it does, append the time to that day. If it doesn't, create a new entry for that day.
            const existingDayIndex = newArray.findIndex((day) => day.day_id === item.day_id)
            if (existingDayIndex !== -1) {
                // Day already exists, append the time to that day
                newArray[existingDayIndex].times = newArray[existingDayIndex].times || []
                newArray[existingDayIndex].times.push({
                    id: item.id,
                    time:`${item.start_time_minute}-${item.end_time_minute}`
                })
            } else {
                // Day doesn't exist, create a new entry for that day
                newArray.push({
                    day_id: item.day_id,
                    times: [{
                        id: item.id,
                        time: `${item.start_time_minute}-${item.end_time_minute}`
                    }]
                })
            }
        })        

        return newArray
    }

    const daypartingDisplayData = getDisplayData(getDayPartingFromData(data))
    const [selectedDays, setSelectedDays] = useState([])
    const [startTime, setStartTime] = useState('')
    const [endTime, setEndTime] = useState('')

    const setDayPartingOnData = (campaignData, nextDayParting) => {
        return { ...campaignData, dayparting: { ...campaignData.dayparting, schedule: nextDayParting }}
    }

    const daysOfWeek = [
        { id: 0, label: 'mo' },
        { id: 1, label: 'tu' },
        { id: 2, label: 'we' },
        { id: 3, label: 'th' },
        { id: 4, label: 'fr' },
        { id: 5, label: 'sa' },
        { id: 6, label: 'su' }
    ]

    const handleDayToggle = (dayId) => {
        setSelectedDays((currentDays) =>
            currentDays.includes(dayId)
                ? currentDays.filter((id) => id !== dayId)
                : [...currentDays, dayId]
        )
    }

    const timeStringToMinutes = (timeString) => {
        const [hours, minutes] = timeString.split(':').map(Number)
        return (hours * 60) + minutes
    }

    const handleAdd = () => {
        if (!selectedDays.length || !startTime || !endTime) {
            return
        }

        const startMinutes = timeStringToMinutes(startTime)
        const endMinutes = timeStringToMinutes(endTime)

        if (endMinutes <= startMinutes) {
            showSystemMessage('error', 'End time must not be earlier than start time.')
            return
        }

        const currentDayParting = getDayPartingFromData(data)
        const hasOverlap = selectedDays.some((dayId) =>
            currentDayParting.some((item) =>
                item.day_id === dayId
                && startMinutes < item.end_time_minute
                && endMinutes > item.start_time_minute
            )
        )

        if (hasOverlap) {
            showSystemMessage('error', 'This time range overlaps an existing active dayparting schedule.')
            return
        }

        const nextItems = selectedDays.map((dayId) => ({
            id: `local-${dayId}-${startMinutes}-${endMinutes}-${Date.now()}`,
            day_id: dayId,
            start_time_minute: startMinutes,
            end_time_minute: endMinutes
        }))

        setData((currentData) => {
            const latestDayParting = getDayPartingFromData(currentData)
            console.log(setDayPartingOnData(currentData, [...latestDayParting, ...nextItems]))
            return setDayPartingOnData(currentData, [...latestDayParting, ...nextItems])
        })
        setSelectedDays([])
        setStartTime('')
        setEndTime('')
        setIsDisabled(false)
    }

    const handleDelete = (idToDelete) => {
        setData((currentData) => {
            const currentDayParting = getDayPartingFromData(currentData)
            const nextDayParting = currentDayParting.filter((item) => item.id !== idToDelete)
            return setDayPartingOnData(currentData, nextDayParting)
        })
        setIsDisabled(false)
    }

    const dayLabelById = {
        0: 'Mon',
        1: 'Tue',
        2: 'Wed',
        3: 'Thu',
        4: 'Fri',
        5: 'Sat',
        6: 'Sun'
    }

    const formatMinutes = (minutes) => {
        const hours = Math.floor(minutes / 60)
        const mins = minutes % 60

        return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`
    }

    return (
        <Card className="mb-2">
            <Card.Header>
                <div className="d-flex justify-content-start align-items-center">
                    <div>Dayparting</div>                    
                </div>
            </Card.Header>
            <div className="d-flex align-items-center mx-2 my-1">
                <label className="mx-2 my-1">Dayparting Enabled</label>
                <div>
                    <select
                        className="form-control"
                        value={data?.dayparting?.enabled ? 'Y' : 'N'}
                        // disabled={data?.status?.value === 'C'}
                        onChange={(e) => {
                            const enabled = e.target.value === 'Y'
                            setData((currentData) => ({
                                ...currentData,
                                dayparting: {
                                    ...currentData.dayparting,
                                    enabled
                                }
                            }))
                            setIsDisabled(false)
                        }}
                    >
                        <option value="Y">Yes</option>
                        <option value="N">No</option>
                    </select>
                </div>
            </div>
            {(data?.dayparting?.enabled && daypartingDisplayData.length > 0) &&
                <div className="alert alert-info mx-2 my-1">Dayparting is enabled. The campaign will ONLY be active during the schedules appearing below.</div>
            }
            {
                data?.dayparting?.enabled &&
                    <>
                        <table className="table table-sm mb-3 table-striped table-hover border-bottom">
                            <thead>
                                <tr>
                                    <th>Day</th>
                                    <th>Schedule</th>
                                </tr>
                            </thead>
                            <tbody>
                                {daypartingDisplayData.length > 0 ? (
                                    daypartingDisplayData.map((item) => (
                                        <tr key={item.day_id}>
                                            <td>{dayLabelById[item.day_id] || item.day_id}</td>
                                            <td>
                                                {item.times.map((time) => (
                                                    <div key={time.id} className="d-flex align-items-center">
                                                        {formatMinutes(time.time.split('-')[0])} - {formatMinutes(time.time.split('-')[1])}
                                                        <button className="btn btn-sm"><Trash2 size={12} color="red" onClick={() => handleDelete(time.id)} /></button>                                            
                                                    </div>
                                                ))}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="4" className="text-muted">No day parting.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        <div className="m-3 d-flex align-items-end flex-wrap">
                            {daysOfWeek.map((day) => (
                                <div key={day.id} className="d-flex flex-column align-items-center mr-2">
                                    <small className="text-uppercase">{day.label}</small>
                                    <Form.Check
                                        type="checkbox"
                                        id={`day-parting-day-${day.id}`}
                                        checked={selectedDays.includes(day.id)}
                                        onChange={() => handleDayToggle(day.id)}
                                    />
                                </div>
                            ))}
                            <Form.Group className="mr-2 mb-0">
                                <Form.Label>Start time</Form.Label>
                                <Form.Control
                                    type="time"
                                    value={startTime}
                                    onChange={(event) => setStartTime(event.target.value)}
                                />
                            </Form.Group>
                            <Form.Group className="mr-2 mb-0">
                                <Form.Label>End time</Form.Label>
                                <Form.Control
                                    type="time"
                                    value={endTime}
                                    onChange={(event) => setEndTime(event.target.value)}
                                />
                            </Form.Group>
                            <Button variant="primary" onClick={handleAdd}>
                                Add
                            </Button>
                        </div>   
                    </>
            }
                     
        </Card>
    )
}

export default DayParting
